import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  ExclamationCircleIcon,
  PauseCircleIcon,
  PlayCircleIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from '@heroicons/react/24/solid';
import Tooltip from '../Tooltip';

const PlaybackButtonGroup = ({ hasError, isLoading, isPlaying, onTogglePlayback, onWinding }) => {
  const { t } = useTranslation('components');

  const onFastRewind = useCallback(onWinding, [onWinding]);

  return (
    <div className="flex gap-2 items-center">
      <button
        type="button"
        className="relative text-blue-500 h-[30px]"
        onClick={() => onFastRewind(-10)}
      >
        <span className="absolute left-0 bottom-0 text-[8px]">10</span>
        <ArrowUturnLeftIcon className="h-5 w-5" />
      </button>
      <button type="button" className="flex items-center" onClick={onTogglePlayback}>
        <div className="flex items-center">
          {!hasError ? (
            <Tooltip
              title={isPlaying ? t('VoiceMessage.Player.pause') : t('VoiceMessage.Player.play')}
            >
              <span className="focus:outline-none flex items-center text-blue-500">
                {isLoading && <div className="spinner-primary p-4" />}
                {!isLoading &&
                  (isPlaying ? (
                    <PauseCircleIcon className="h-10 w-10 text-blue-500" />
                  ) : (
                    <PlayCircleIcon className="h-10 w-10 text-blue-500" />
                  ))}
              </span>
            </Tooltip>
          ) : (
            <Tooltip title={t('VoiceMessage.Player.errorTooltip')}>
              <ExclamationCircleIcon className="h-10 w-10 text-red-600" />
            </Tooltip>
          )}
        </div>
      </button>
      <button
        type="button"
        className="relative text-blue-500 h-[30px]"
        onClick={() => onFastRewind(10)}
      >
        <span className="absolute right-0 bottom-0 text-[8px]">10</span>
        <ArrowUturnRightIcon className="h-5 w-5 text-blue-500" />
      </button>
    </div>
  );
};

PlaybackButtonGroup.propTypes = {
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPlaying: PropTypes.bool,
  onTogglePlayback: PropTypes.func.isRequired,
  onWinding: PropTypes.func.isRequired,
};

PlaybackButtonGroup.defaultProps = {
  hasError: false,
  isLoading: false,
  isPlaying: false,
};

export default PlaybackButtonGroup;
